import { Download, MessageCircle } from "lucide-react";

const apps = [
  {
    id: "newbraz",
    name: "New Braz",
    desc: "App oficial com tecnologia P2P",
    img: "/assets/newbraz.png",
    code: "1586660",
    link: "https://zeferius.com/downloads/newbraz.apk",
    file: "newbraz.apk",
    badge: "RECOMENDADO",
  },
  {
    id: "newhybrid",
    name: "New Hybrid",
    desc: "Solução híbrida IPTV + P2P",
    img: "/assets/newhybrid.jpeg",
    code: "1941290",
    link: "https://zeferius.com/downloads/newhybrid.apk",
    file: "newhybrid.apk",
    badge: "RECOMENDADO",
  },
  {
    id: "iboplayer",
    name: "IBO Player",
    desc: "Player premium para Smart TV",
    img: "/assets/iboplayer.png",
    code: "LOJA DA TV",
    link: null,
    badge: "NOVO",
  },
  {
    id: "smarters",
    name: "Smarters Pro",
    desc: "Player universal popular",
    img: "/assets/smarters.png",
    code: "506942",
    link: "https://zeferius.com/downloads/smarters.apk",
    file: "smarters.apk",
  },
  {
    id: "dreamtv",
    name: "Dream TV",
    desc: "Interface elegante e fluída",
    img: "/assets/dreamtv.jpeg",
    code: "8627648",
    link: "https://zeferius.com/downloads/dreamtv.apk",
    file: "dreamtv.apk",
  },
  {
    id: "purpleiptv",
    name: "Purple IPTV",
    desc: "Player completo e estável",
    img: "/assets/purpleiptv.jpeg",
    code: "DIRETO",
    link: "https://zeferius.com/downloads/purpleiptv.apk",
    file: "purpleiptv.apk",
  },
  {
    id: "ispiptv",
    name: "ISP IPTV",
    desc: "Leve e otimizado",
    img: "/assets/ispiptv.jpeg",
    code: "DIRETO",
    link: "https://zeferius.com/downloads/ispiptv.apk",
    file: "ispiptv.apk",
  },
  {
    id: "vejov3",
    name: "VEJO V3",
    desc: "Leve e rápido",
    img: "/assets/vejov3.png",
    code: "8573579",
    link: "https://zeferius.com/downloads/vejov3.apk",
    file: "vejov3.apk",
  },
  {
    id: "xcloud",
    name: "XCLOUD TV",
    desc: "Design moderno e intuitivo",
    img: "/assets/xcloud.png",
    code: "740644",
    link: "https://zeferius.com/downloads/xcloud.apk",
    file: "xcloud.apk",
  },
];

export const AppsDownload = ({ onCta }) => (
  <section id="downloads" data-testid="apps-download-section" className="py-24 px-4 sm:px-6">
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-14">
        <p className="text-[#FF5A00] text-sm font-bold uppercase tracking-[0.25em] mb-3">Downloads</p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter mb-4" style={{ fontFamily: "Outfit, sans-serif" }}>
          Apps <span className="text-[#FF5A00]">Compatíveis</span>
        </h2>
        <p className="text-white/55 max-w-xl mx-auto text-base">
          Escolha o player que preferir. Todos funcionam perfeitamente com nosso serviço.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {apps.map((app) => (
          <div
            key={app.id}
            data-testid={`app-card-${app.id}`}
            className={`relative bg-[#0F0F13] border rounded-2xl p-6 text-center flex flex-col transition-all duration-300 hover:-translate-y-1 ${
              app.badge === "RECOMENDADO"
                ? "border-[#FF5A00]/60 shadow-[0_0_30px_rgba(255,90,0,0.12)]"
                : "border-white/10 hover:border-white/25"
            }`}
          >
            {app.badge && (
              <span
                className={`absolute -top-3 left-1/2 -translate-x-1/2 text-xs font-bold uppercase tracking-wider px-4 py-1 rounded-full ${
                  app.badge === "RECOMENDADO" ? "bg-[#FF5A00] text-white" : "bg-[#25D366] text-black"
                }`}
              >
                {app.badge}
              </span>
            )}
            <div className="h-24 flex items-center justify-center mb-4 mt-2">
              <img
                src={app.img}
                alt={`${app.name} logo`}
                loading="lazy"
                className="max-h-20 max-w-[140px] object-contain rounded-xl"
              />
            </div>
            <h3 className="text-lg font-bold mb-1" style={{ fontFamily: "Outfit, sans-serif" }}>{app.name}</h3>
            <p className="text-sm text-white/50 mb-5">{app.desc}</p>
            <div className="mt-auto border-t border-white/10 pt-4 space-y-3">
              <div className="bg-black/40 rounded-lg p-3">
                <p className="text-[11px] text-white/40 mb-0.5 uppercase tracking-wider">Código Downloader</p>
                <p
                  data-testid={`app-code-${app.id}`}
                  className="text-2xl font-black text-[#FF5A00] tracking-tight"
                  style={{ fontFamily: "Outfit, sans-serif" }}
                >
                  {app.code}
                </p>
              </div>
              {app.link ? (
                <a
                  data-testid={`app-download-${app.id}`}
                  href={app.link}
                  download={app.file}
                  className="w-full bg-[#FF5A00] hover:bg-[#FF7A33] text-white font-bold rounded-lg py-3 transition-colors flex items-center justify-center gap-2 text-sm"
                >
                  <Download className="w-4 h-4" /> Baixar Agora
                </a>
              ) : (
                <button
                  data-testid={`app-download-${app.id}`}
                  onClick={() => onCta(app.name)}
                  className="w-full bg-[#25D366] hover:bg-[#1EBE5D] text-white font-bold rounded-lg py-3 transition-colors flex items-center justify-center gap-2 text-sm"
                >
                  <MessageCircle className="w-4 h-4" /> Como Instalar
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 bg-[#0F0F13] border border-white/10 rounded-2xl p-8 sm:p-10">
        <h3 className="text-xl sm:text-2xl font-black tracking-tighter mb-6 text-center" style={{ fontFamily: "Outfit, sans-serif" }}>
          Como baixar o app <span className="text-[#FF5A00]">New Braz</span> na sua TV
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-black/40 border border-white/10 rounded-xl p-6">
            <p className="text-sm font-bold text-[#FF5A00] uppercase tracking-wider mb-3">Via Downloader (Recomendado)</p>
            <ol className="space-y-2 text-sm text-white/65 list-decimal list-inside">
              <li>Baixe o app <strong className="text-white">"Downloader"</strong> na loja oficial da sua TV</li>
              <li>Abra o Downloader</li>
              <li>Digite o código: <strong data-testid="downloader-code" className="text-[#FF5A00] text-lg">857809</strong></li>
              <li>O app New Braz será baixado e instalado automaticamente</li>
            </ol>
          </div>
          <div className="bg-black/40 border border-white/10 rounded-xl p-6">
            <p className="text-sm font-bold text-[#25D366] uppercase tracking-wider mb-3">Download Direto (APK)</p>
            <ol className="space-y-2 text-sm text-white/65 list-decimal list-inside mb-4">
              <li>Entre em contato via WhatsApp</li>
              <li>Nossa equipe envia o link do arquivo <strong className="text-white">newbraz.apk</strong></li>
              <li>Baixe, instale, faça login e comece a assistir!</li>
            </ol>
            <button
              data-testid="cta-install-help"
              onClick={() => onCta("instalação")}
              className="w-full bg-[#25D366] hover:bg-[#1EBE5D] text-white font-bold rounded-lg py-3 transition-colors text-sm"
            >
              Pedir Ajuda na Instalação
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
);
